/* eslint-disable */
(() => {
  if (window.__stickyProductCTASyncInitialized) return;
  window.__stickyProductCTASyncInitialized = true;

  /**
   * Sets up price syncing for one sticky CTA bar.
   * When a swatch changes inside the bar's product-card-with-variants,
   * we look up the matching variant from the embedded JSON and update
   * the price elements with the pre-formatted strings from Liquid.
   */
  const initStickyVariantPriceSync = (stickyCTA) => {
    const card = stickyCTA.querySelector('product-card-with-variants');
    const priceEl = stickyCTA.querySelector('[data-sticky-sale-price]');
    const compareEl = stickyCTA.querySelector('[data-sticky-compare-price]');
    if (!card || !priceEl || !compareEl) return;

    let variants;
    try {
      variants = JSON.parse(card.querySelector('script.variants').textContent).variants;
    } catch (e) {
      return;
    }
    if (!variants?.length) return;

    // Build { OptionName: selectedValue } from checked swatches inside the card
    const getSelectedOptions = () => {
      const selected = {};
      card.querySelectorAll('product-swatch input[type="radio"]:checked').forEach((input) => {
        const optName = input.closest('.swatch-element')?.getAttribute('data-option');
        if (optName) selected[optName] = input.value;
      });
      return selected;
    };

    // Find the variant whose options object matches every selected option
    const findVariant = (selected) =>
      variants.find((v) =>
        Object.entries(selected).every(([key, val]) => v.options[key] === val)
      ) ?? null;

    const updatePrice = () => {
      const variant = findVariant(getSelectedOptions());
      if (!variant) return;

      const onSale = Boolean(variant.compare_at_price);

      priceEl.textContent = variant.price;
      priceEl.classList.toggle('price--sale-price', onSale);
      priceEl.classList.toggle('price--regular-price', !onSale);

      compareEl.textContent = onSale ? variant.compare_at_price : '';
      compareEl.classList.toggle('hidden', !onSale);
    };

    card.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) {
        requestAnimationFrame(updatePrice);
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll('.sticky-product-cta').forEach(initStickyVariantPriceSync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
